import type { AcceptInvitationPayload, LoginPayload, VerifyInvitationResponse } from '@/api/auth/types.ts'
import { axiosClient } from '@/api/axios.ts'

export const login = (payload: LoginPayload) => {
  return axiosClient.post('/auth/login', payload)
}

export const forgotPassword = (email: string) => {
  return axiosClient.post('/auth/forgot-password', { email })
}

export const checkRecoveryCode = (code: string, token: string) => {
  return axiosClient.post(
    '/auth/check-recovery-code',
    { code },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  )
}

export const resetPassword = (password: string, confirmPassword: string, code: string, token: string) => {
  return axiosClient.post(
    '/auth/reset-password',
    {
      password,
      confirmPassword,
      code,
    },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  )
}

export const verifyInvitation = (token: string) => {
  return axiosClient.get<VerifyInvitationResponse>('/auth/verify-invitation', {
    params: { token },
  })
}

export const acceptInvitation = (payload: AcceptInvitationPayload) => {
  return axiosClient.post('/auth/accept-invitation', payload)
}

export const refreshTokenApi = (refreshToken: string) => {
  return axiosClient.post('/auth/refresh', { refreshToken })
}

export const logoutApi = () => {
  return axiosClient.post('/auth/logout')
}
